import 'intersection-observer'
import * as React from 'react'
import { InView } from 'react-intersection-observer'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { decodeHTMLEntities } from '../../../../../helpers'
import { CMSState, Link as LinkType } from '../../../../cms/blocks/types.gen'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { getImageAttribute } from '../../../utils/extra_images.mod'
import { blockInviewHandler } from '../../../utils/inview_utils'

export type AttentionAttributes = {
  blockName: 'vidda/attention'
  title: string
  image?: WordPress.MediaResponse
  link?: LinkType
}

export interface AttentionInterface {
  blockName: 'vidda/attention'
  attrs: AttentionAttributes
}

export type AttentionBlockProps<extra_iamges> = AttentionAttributes

export type AttentionBlockStyle = Partial<{
  block_contentwidth_classname: string
  block_fullwidth_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  visual_classname: string
  image_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function AttentionBlock<customBlockData, extra_images>(
  props: AttentionBlockProps<extra_images>,
  options?: { style?: AttentionBlockStyle; key?: string }
): IOWidget<
  CMSState<customBlockData, extra_images, PublicSite_CustomPageData>,
  Action<CMSState<customBlockData, extra_images, never>>
> {
  console.log('attentionprops', props)
  return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: (_) => (
        <InView
          as="section"
          onChange={(inView) => blockInviewHandler('attention', inView, 'block-attention', 'block--inview')}
          triggerOnce={false}
          threshold={0.125}
          className="block block--attention grid--spacing"
          id="block-attention"
        >
          <div className="block__inner">
            <div className="block__content container--xl grid--block">
              {props.title && (
                <header className="block__header">
                  <h2 className="block__title typo--l">{decodeHTMLEntities(props.title)} </h2>
                </header>
              )}
              {props.link && (
                <footer className="block__footer">
                  <a className="link link--primary" href={props.link.url}>
                    {props.link.title}
                  </a>
                </footer>
              )}
            </div>
            {props.image && (
              <div className="block__visual fit-object">
                <img
                  src={getImageAttribute(props.image, 'attention', 'source_url')}
                  width={getImageAttribute(props.image, 'attention', 'width')}
                  height={getImageAttribute(props.image, 'attention', 'height')}
                  className="attention__image"
                  alt={props.image.alt_text ? props.image.alt_text : ''}
                />
              </div>
            )}
          </div>
        </InView>
      ),
    })
}
